/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DraggingState/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function DraggingState({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/RescheduleQueue/DraggingState"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let tabIsDraggingTimegridAppointmentValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'is_dragging_timegrid_appointment',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(tabIsDraggingTimegridAppointmentValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}